module.exports = __webpack_public_path__ + "ce7fb5e0dccebf72794d84baa5a77ab3.png";